import { cn } from "@/lib/utils";

interface FormHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  variant?: "page" | "modal";
}

export function FormHeader({
  title,
  description,
  children,
  className,
  titleClassName,
  descriptionClassName,
  variant = "page",
}: FormHeaderProps) {
  const variantClasses = {
    page: "px-6 py-6",
    modal: "bg-muted/50 px-6 py-6 rounded-t-lg border-b border-border",
  };

  return (
    <div className={cn(variantClasses[variant], className)}>
      <div className="flex items-start justify-between space-x-3">
        <div className="space-y-1">
          <h1 className={cn("text-2xl font-bold text-foreground", titleClassName)}>{title}</h1>
          {description && (
            <p className={cn("text-sm text-muted-foreground", descriptionClassName)}>
              {description}
            </p>
          )}
        </div>
        {children && <div className="flex h-7 items-center">{children}</div>}
      </div>
    </div>
  );
}
